import React from "react";

const inputClass =
  "w-full rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-100 outline-none transition focus:border-indigo-400";

export const AWARD_TYPES = [
  { value: "season", label: "فصل" },
  { value: "year", label: "سال" },
] as const;

export type AwardFormState = {
  title: string;
  type: string;
  rank: string;
};

type Props = {
  form: AwardFormState;
  onChange: (field: keyof AwardFormState, value: string) => void;
};

export default function AwardFormFields({ form, onChange }: Props) {
  return (
    <>
      <label className="space-y-2 md:col-span-2">
        <span className="text-sm text-slate-300">عنوان</span>
        <input
          value={form.title}
          onChange={(e) => onChange("title", e.target.value)}
          className={inputClass}
          placeholder="عنوان جایزه را وارد کنید..."
        />
      </label>
      <label className="space-y-2">
        <span className="text-sm text-slate-300">نوع</span>
        <select
          className={inputClass}
          value={form.type}
          onChange={(e) => onChange("type", e.target.value)}
        >
          <option value="">انتخاب کنید</option>
          {AWARD_TYPES.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
      </label>
      <label className="space-y-2">
        <span className="text-sm text-slate-300">رتبه</span>
        <input
          type="number"
          min={1}
          value={form.rank}
          onChange={(e) => onChange("rank", e.target.value)}
          className={inputClass}
          placeholder="۱"
        />
      </label>
    </>
  );
}

export function isAwardFormValid(form: AwardFormState) {
  const rank = Number(form.rank);
  const validType = AWARD_TYPES.some((item) => item.value === form.type);
  return Boolean(form.title.trim() && validType && Number.isInteger(rank) && rank >= 1);
}

export function emptyAwardForm(): AwardFormState {
  return {
    title: "",
    type: "",
    rank: "",
  };
}

export function awardTypeLabel(type: string) {
  const found = AWARD_TYPES.find((item) => item.value === type);
  return found?.label ?? type;
}
